(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OrderModificationController', OrderModificationController);

    OrderModificationController.$inject = ['$scope', 'Principal', 'LoginService', '$state','$location','MessageService', 'ParseLinks', 'SalesOrder','$uibModalInstance', 'entity', 'Express'];

    function OrderModificationController ($scope, Principal, LoginService, $state,$location,MessageService, ParseLinks, SalesOrder, $uibModalInstance, entity, Express) {
        var vm = this;
        vm.order = entity;
        vm.status_info = vm.order[0].status;
        vm.isDelivery = $state.current.name == 'orderSelf' && $location.$$search.state == 'Collect'
        vm.data={};
        vm.expressCompanies = [];

        vm.deliveryMethodList = [
            {name:'自送', id: "Self"},
            {name:'快递', id: "Delivery"}
        ];

        if(vm.status_info == 'Assigned'){
            vm.statusList=[
                {name:'生产中', id:'Producing'},
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Producing'){
            vm.statusList=[
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Delivered'){
            vm.statusList=[
                {name:'已回件', id:'Collect'},
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }
        if(vm.status_info == 'Collect'){
            vm.statusList=[
                {name:'已发货', id:'Delivered'},
                {name:'已揽件', id:'Receiving'},
                {name:'已签收', id:'Received'}
            ]
        }



        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        $scope.statusChange = function(){
            vm.data.downLoadDate = "";
            Express.getAll(function(res){
                res.forEach(function (item) {
                    // if(item.enable && vm.order[0].supplierId == item.supplierId){
                    if(item.enable){
                        vm.expressCompanies.push(item)
                    }
                })
            });
        }
        function formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = String(d.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          }

        if(vm.isDelivery){
            vm.data.deliveryType = 'Delivery'
            vm.data.deliveryDate = formatDate(new Date());
            Express.getAll(function(res){
                vm.expressCompanies = [];
                res.forEach(function (item) {
                    // if(item.enable && vm.order[0].supplierId == item.supplierId){
                    if(item.enable){
                        vm.expressCompanies.push(item);
                    }
                });
            }, function(error) {
                MessageService.error('获取快递公司失败');
            });
        }
        //保存
        $scope.save = function () {
            vm.data.downLoadDate = angular.copy(angular.element("#downLoadDate").val());
            vm.data.deliveryDate = angular.copy(angular.element("#deliveryDate").val());
            if(!vm.isDelivery && !vm.data.status){
                MessageService.error("状态不能为空");
                return;
            }
            if(!vm.isDelivery && (vm.data.status == 'Producing' && !vm.data.downLoadDate)){
                MessageService.error("下载时间不能为空");
                return;
            }

            if(vm.isDelivery && !vm.data.deliveryType){
                MessageService.error("配送方式不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.deliveryComp){
                MessageService.error("快递公司不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.deliveryDate){
                MessageService.error("发货日期不能为空");
                return;
            }
            if((vm.data.status == 'Delivered' || vm.isDelivery) && vm.data.deliveryType == 'Delivery' && !vm.data.logisticsNumber){
                MessageService.error("快递单号不能为空");
                return;
            }
            var _data=[];
            var  expressSetting = vm.expressCompanies.find(function(com){
                return com.name == vm.data.deliveryComp
            })

            if(vm.data.deliveryType == 'Self'){
                vm.data.deliveryDate = formatDate(new Date());
            }
            vm.order.forEach(function (item) {
                _data.push({
                    status: vm.isDelivery ?'Delivered': vm.data.status,
                    downLoadDate: vm.data.downLoadDate,
                    deliveryComp: vm.data.deliveryComp,
                    expressSettingId:expressSetting ? expressSetting.id : '',
                    logisticsNumber: vm.data.logisticsNumber,
                    deliveryDate: vm.data.deliveryDate,
                    orderId: item.id,
                })
            })
            SalesOrder.updateOrderBatch(_data, function (res) {
                MessageService.success("发货成功");
                $uibModalInstance.close(true);
            }, function (error) {
                MessageService.error("发货失败");
            });
        }
    }
})();
